import axios, { AxiosPromise } from 'axios'
import { ImpressaoGuiaEncaminhamentoDto } from 'view/atendimentos/detail/soap/plano/compartilhamento-cuidado/impressao/model-impressaoGuiaEncaminhamento'

export class ImpressaoGuiaEncaminhamentoCuidado {
  imprimirGuiaEncaminhamentoCuidado(input: ImpressaoGuiaEncaminhamentoDto): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirGuiaEncaminhamentoCuidado', input, { responseType: 'blob' })
  }
}
